import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function EmployerOfChoice(){
    const { t } = useTranslation();

    return(
        <article id="whyjoinus">
            <section className="employer-of-choice">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t(`lifeatcentrico.employerofchoice.title`)}</div>
                        </Col>
                    </Row>
                    <Row className="mt-5">
                        <Col md={12}>
                            <Row className="mb-1 row-style">
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder workculture"></div>
                                        <div className="contents">
                                            <div className="title">{t(`lifeatcentrico.employerofchoice.workculture.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.workculture.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder timeoff"></div>
                                        <div className="contents">
                                            <div className="title">{t(`lifeatcentrico.employerofchoice.timeoff.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.timeoff.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-1 row-style bg">
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder remotework"></div>
                                        <div className="contents">
                                        <div className="title">{t(`lifeatcentrico.employerofchoice.remotework.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.remotework.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder upskill"></div>
                                        <div className="contents">
                                        <div className="title">{t(`lifeatcentrico.employerofchoice.upskill.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.upskill.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-1 row-style">
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder health"></div>
                                        <div className="contents">
                                        <div className="title">{t(`lifeatcentrico.employerofchoice.health.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.health.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="content-wrapper">
                                        <div className="icon-placeholder parental"></div>
                                        <div className="contents">
                                            <div className="title">{t(`lifeatcentrico.employerofchoice.parental.title`)}</div>
                                            <div className="description">{t(`lifeatcentrico.employerofchoice.parental.description`)}</div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}